import { NgModule } from '@angular/core';
import { BillingBaseComponent } from './billing-base.component';
import { HeaderModule } from 'src/app/controls/header/header.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [BillingBaseComponent],
    imports: [HeaderModule, CommonModule, FormsModule],
    exports: [BillingBaseComponent],
    providers: [],
    bootstrap: [BillingBaseComponent]
})
export class BillingBaseModule { }